import { AreaItem } from '@/types/cms/AreaItem'
import Picture from '@/elements/widgets/Picture/Picture'

const PictureInlineTop = ({ item }: { item: AreaItem }) => {
  return <Picture item={item} top={true} />
}

export default PictureInlineTop
